import {
  LOGIN_NUMBER_VERIFY,
  LOGIN_NUMBER_VERIFY_SUCCESS,
  LOGIN_NUMBER_VERIFY_FAILURE,
} from 'store/verifyNumber/verifyNumberAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const loginVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_NUMBER_VERIFY:
      return { ...state, loading: true };
    case LOGIN_NUMBER_VERIFY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case LOGIN_NUMBER_VERIFY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default loginVerifyReducer;
